export enum InputSize {
  SM = "SM",
  BASE = "BASE"
}

export const inputSize = {
  [InputSize.BASE]: "h-12",
  [InputSize.SM]: "h-10"
};

export const getDaysInMonth = (year: number, month: number) =>
  new Date(year, month, 0).getDate();
